const tabLabel = "Summary View";

export { tabLabel };
